import { Reducer } from 'redux';
import { IFabricationContract } from '../fabrication-contracts/types';
import {
  Types,
  IConstructionRegistrationState,
  IContractsAndConstructionsState,
  INITIAL_CONSTRUCTION_REGISTRATION
} from './types';

const INITIAL_STATE: IContractsAndConstructionsState = {
  constructionRegistration: INITIAL_CONSTRUCTION_REGISTRATION,

  contractsManager: {
    loading: false,
    error: false,
    customerContracts: [],
    highlightNewContracts: false
  },

  canShowNewConstructionModal: false
};

type CustomAction = {
  type: Types;
  payload: {
    constructionRegistration: IConstructionRegistrationState;
    selectedCustomerId: string;
    customerContracts: IFabricationContract[];
    highlightNewContracts: boolean;
    bpError: boolean;
  };
};

const reducer: Reducer<IContractsAndConstructionsState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.UPDATE_CONTRUCTION_REGISTRATION_SETTINGS:
      return {
        ...state,
        constructionRegistration: action.payload.constructionRegistration
      };

    case Types.LOAD_CUSTOMER_CONTRACTS:
      return {
        ...state,
        constructionRegistration: INITIAL_CONSTRUCTION_REGISTRATION,
        contractsManager: {
          ...state.contractsManager,
          customerContracts: [],
          loading: true,
          error: false,
          bpError: false,
          selectedCustomerId: action.payload.selectedCustomerId
        }
      };

    case Types.LOAD_CUSTOMER_CONTRACTS_V2:
      return {
        ...state,
        constructionRegistration: INITIAL_CONSTRUCTION_REGISTRATION,
        contractsManager: {
          ...state.contractsManager,
          customerContracts: [],
          loading: true,
          error: false,
          bpError: false,
          selectedCustomerId: action.payload.selectedCustomerId
        }
      };

    case Types.LOAD_CUSTOMER_CONTRACTS_SUCCESS:
      return {
        ...state,
        contractsManager: {
          ...state.contractsManager,
          customerContracts: action.payload.customerContracts,
          loading: false,
          error: false
        }
      };

    case Types.LOAD_CUSTOMER_CONTRACTS_FAILURE:
      return {
        ...state,
        contractsManager: {
          ...state.contractsManager,
          loading: false,
          error: true,
          bpError: action.payload.bpError
        }
      };

    case Types.SET_HIGHLIGHT_NEW_CONTRACTS:
      return {
        ...state,
        contractsManager: {
          ...state.contractsManager,
          highlightNewContracts: action.payload.highlightNewContracts
        }
      };

    case Types.FINISH_CONSTRUCTION_REGISTRATION:
      return {
        ...state,
        constructionRegistration: {
          ...state.constructionRegistration,
          loading: true,
          error: false,
          success: false
        }
      };

    case Types.FINISH_CONSTRUCTION_REGISTRATION_SUCCESS:
      return {
        ...state,
        constructionRegistration: {
          ...state.constructionRegistration,
          loading: false,
          error: false,
          success: true
        }
      };

    case Types.FINISH_CONSTRUCTION_REGISTRATION_FAILURE:
      return {
        ...state,
        constructionRegistration: {
          ...state.constructionRegistration,
          loading: false,
          error: true,
          success: false
        }
      };

    case Types.CLEAR_CONTRUCTION_REGISTRATION_SETTINGS:
      return {
        ...state,
        constructionRegistration: {
          ...INITIAL_STATE.constructionRegistration
        }
      };

    case Types.CLEAR_CONTRACTS_AND_CONSTRUCTIONS_STATE:
      return INITIAL_STATE;

    case Types.OPEN_NEW_CONSTRUCTION_MODAL:
      return {
        ...state,
        canShowNewConstructionModal: true
      };

    case Types.CLOSE_NEW_CONSTRUCTION_MODAL:
      return {
        ...state,
        canShowNewConstructionModal: false
      };
    default:
      return state;
  }
};

export default reducer;
